import { FEATURE_FLAGS_FOR_SELLER } from '@savgroup-front-common/constants';
import { useGetFeatureFlagsQuery } from '@savgroup-front-common/core/api/Authorization/useGetFeatureFlagsQuery';

import { useAppContext } from '@/view/app/App.context';

interface UseHasPackingParcelModuleArgs {
  shouldSuspend?: boolean;
}

export function useHasPackingParcelModule({
  shouldSuspend = false,
}: UseHasPackingParcelModuleArgs = {}): boolean {
  const { selectedSeller } = useAppContext();

  return useGetFeatureFlagsQuery({
    featureFlag: [FEATURE_FLAGS_FOR_SELLER.PACKING_PARCEL_MODULE],
    sellerId: selectedSeller?.id,
    suspense: shouldSuspend,
  });
}
